var _path, _circle;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCoditasCommaWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 217,
    viewBox: "0 0 80 217",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0834748 118.406C1.90359 149.589 28.8196 152.035 38.6785 150.507L0.0834748 217H28.8128C51.6248 187.997 59.4781 175.937 66.9574 161.992C91.2216 116.753 77.294 93.8669 60.2263 84.3532C42.6492 74.5555 -2.19167 79.4274 0.0834748 118.406Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 33,
    r: 33,
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoditasCommaWhite);
export default "data:image/svg+xml,%3csvg width='80' height='217' viewBox='0 0 80 217' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M0.0834748 118.406C1.90359 149.589 28.8196 152.035 38.6785 150.507L0.0834748 217H28.8128C51.6248 187.997 59.4781 175.937 66.9574 161.992C91.2216 116.753 77.294 93.8669 60.2263 84.3532C42.6492 74.5555 -2.19167 79.4274 0.0834748 118.406Z' fill='white'/%3e %3ccircle cx='35' cy='33' r='33' fill='white'/%3e %3c/svg%3e";
export { ForwardRef as ReactComponent };